import { Updater } from "use-immer"
// my imports:
import * as Util from "@/app/lib/system/util"
import WordModule from "@/app/lib/game-state/word-module"
import LetterModule from "@/app/lib/game-state/letter-module"
import UI from "@/app/lib/ui/ui"
import InputHandler from "@/app/lib/input/input-handler"
import { AnyGameObj } from "@/app/lib/game-state/game-types";

// MANAGES ONCHANGE TEXT VALUE INPUTS FOR ENTRY SLOTS
export function handleLetterInput({
    wordIndex, letterPosition, event, game, ui
} : {
    wordIndex: number,
    letterPosition: number,
    event: React.ChangeEvent<HTMLInputElement>,
    game: AnyGameObj,
    ui: UI,
}) {
    if (game.state.freezeInputs()) {
        return;
    }

    event.stopPropagation();

    const wordModule = game.state.words[wordIndex];
    const letterModule = wordModule.letters[letterPosition];

    // if we are at a given letter, or solved word, we return and allow keydown to handle it
    if (
        wordModule.solved === true
        || letterModule.type === 'given'
    ) {
        return;
    }

    const inputChar: string = event.target.value.toLowerCase();

    const input: InputHandler = new InputHandler({
        wordIndex,
        letterPosition,
        game,
        ui
    });

    // if the input matches the value already in the box, we advance without updating state
    // unless it's empty, then we go backwards
    if (inputChar === letterModule.character) {
        if (inputChar === '') {
            input.goPrevEntry(false);
        }
        input.goNextEntry(false);
        return;
    }

    // otherwise, we check against the core letters
    if (game.state.validateLetter(inputChar)) {
        input.fill(inputChar);
        return;
    } 
}